"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const useStyles = core_1.makeStyles((theme) => ({
    wrapper: {
        margin: "auto",
    },
}));
function Spinner(props) {
    const classes = useStyles();
    return (react_1.default.createElement(core_1.CircularProgress, Object.assign({ className: classes.wrapper, size: 60, color: "primary" }, props)));
}
exports.Spinner = Spinner;
//# sourceMappingURL=spinner.js.map